export default "__VITE_ASSET__fb929e1c__"